import * as React from 'react'
import type {SVGProps} from 'react'
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.75 0H2.25C1.01 0 0 1.01 0 2.25v13.5C0 16.99 1.01 18 2.25 18H9v-6.188H6.75V9H9V6.75a3.374 3.374 0 0 1 3.375-3.375h2.25v2.813H13.5c-.621 0-1.125-.059-1.125.562V9h2.813l-1.126 2.813h-1.687V18h3.375c1.24 0 2.25-1.01 2.25-2.25V2.25C18 1.01 16.99 0 15.75 0"
        />
    </svg>
)
export default SvgFacebook
